import React from "react";
import { Keyword } from "./Keyword";

export class PaperSessionHeadPanel extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            buttonClassName,
            buttonStyle,
            data,
            keywordCounts,
            sessionColor,
            paperCount,
            showPaperCount,
            sessionDuration,
        } = this.props;

        return (
            <div
                className="panel-heading sessioninfo"
                style={{ backgroundColor: sessionColor }}
            >
                <span
                    className={buttonClassName}
                    style={buttonStyle}
                    onClick={this.props.handleClick}
                ></span>

                <div className={this.props.sessionNameClassName}>
                    {data.name}
                    {showPaperCount && (
                        <span className="badge" style={{ marginLeft: "1%" }}>
                            {paperCount} papers - {sessionDuration} mins
                        </span>
                    )}
                </div>
                <div className="sessionshortname">{data.short_name}</div>
                <div className="sessionchair">{data.chair}</div>
                <div className="sessionkw">
                    {keywordCounts.map((keywordCount) => (
                        <Keyword
                            key={keywordCount.keyword.id}
                            keyword={keywordCount.keyword}
                            count={keywordCount.count}
                            bsStyle="label-default"
                            style={{ marginRight: "5px" }}
                        />
                    ))}
                    <b>...</b>
                </div>
                <div className="sessiontrack"></div>
            </div>
        );
    }
}
